<!-- 体验卡下载 -->
<template>
  <div class="basicStyle">
    <div class="experienceCardBox">
      <div class="experienceLeft bg_fff">
        <div class="experienceTitle">
          <div class="left">体验卡下载</div>
          <div class="right" @click="accountsModify">修改体验帐号</div>
        </div>
        <div class="experienceCont">
          <div
            class="experienceItem"
            v-for="(item, index) in experienceInfo.down_list"
            :key="index"
          >
            <QrCode
              v-if="item.down_url"
              :id="item.title"
              :pictureId="'picture_' + item.title"
              :newId="'new_' + item.title"
              :codeUrl="item.down_url"
              :title="item.title"
              :username="experienceInfo.user_info.username"
              :password="experienceInfo.user_info.password"
            />
            <!-- <div class="itemTitle">{{ item.title }}</div>
            <div class="itemImg">
              <QrCode :id="item.title" :codeUrl="item.down_url" />
            </div>
            <div class="itemAccounts">
              体验帐号：{{ experienceInfo.user_info.username }}
            </div>
            <div class="itemPassword">
              密码：{{ experienceInfo.user_info.password }}
            </div>
            <div class="itemBtn">
              <div class="btn" @click="ewmBtn(experienceInfo, index)">
                保存二维码
              </div>
              <div class="btn" @click="imgBtn(experienceInfo, index)">
                保存图片
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="experienceRight bg_fff">
        <div v-html="tyksszhiff_text"></div>
      </div>
    </div>

    <el-dialog :visible.sync="accountsShow" width="415px">
      <div class="accounts_h1">
        <el-input
          type="text"
          placeholder="请输入修改后的帐号"
          v-model="postData.accounts"
          maxlength="11"
          show-word-limit
        ></el-input>
      </div>
      <div class="accounts_h2">修改后原体验帐号将失效不可登录</div>
      <div class="accounts_h3">
        <el-button type="primary" @click="submit">确认修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonApi from "@/api/common";
import { clearObj, deepClone } from "@/utils";
import TableComponents from "@/components/TableComponents.vue";
import MyButton from "@/components/MyButton.vue";
import QrCode from "@/components/QrCode.vue";
// 体验卡下载
export default {
  name: "tobExperienceCard",
  components: { QrCode },
  data() {
    return {
      loading: false,
      queryInfo: {
        type_id: 1,
        limit: 10,
        page: 1,
        total: 0,
      },
      tableList: [],
      timeFrame: [],
      selfnumzbsm: "",
      typeOptions: [{ value: 1, label: "宣传资料" }],
      jsjyguljsy_text: "",
      tyksszhiff_text: "",
      accountsShow: false,
      postData: {
        accounts: "",
      },
      experienceInfo: {},
      codeUrl: "https://www.baidu.com",
    };
  },
  computed: {
    typeMap() {
      return new Map(this.typeOptions.map((item) => [item.value, item.label]));
    },
  },
  created() {
    this.getDic();
    if (this.$route.query.folder_id) {
      this.queryInfo.folder_id = this.$route.query.folder_id;
    }
    this.getTobExperienceInfo();
  },
  methods: {
    // ewmBtn() {
    //   // 保存二维码
    // },
    // imgBtn() {
    //   // 保存图片
    // },
    submit() {
      // 确定提交 experienceAccountUpdate
      if (!this.postData.accounts) {
        this.$message.error("请输入账号");
        return;
      }

      const res = commonApi
        .experienceAccountUpdate({ mobile: this.postData.accounts })
        .then((res) => {
          if (res.code == 200) {
            console.log("tipMessageColse", res);
            this.$message({
              message: res.message,
              type: "success",
            });
            this.getTobExperienceInfo();
            this.accountsShow = false;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    accountsModify() {
      this.postData.accounts = "";
      this.accountsShow = true;
    },
    getDic() {
      commonApi.getInfoToName({ name: "bktzkbzkbText" }).then((res) => {
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            // 收益类型提示
            if (item.key === "tyksszhiff_text") {
              this.tyksszhiff_text = item.value;
            }
          });
        }
      });
    },
    // 列表数据
    async getTobExperienceInfo() {
      const res = await commonApi.getTobExperienceInfo();
      if (res.code == 200) {
        this.experienceInfo = res.data;
        console.log("getTobExperienceInfo", res.data);
        // this.queryInfo.total = res.data.file_list.total;
      } else {
        this.$message.error(res.message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 230px;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0;
    .el-button {
      margin: 0 5px 10px 0;
    }
  }

  // 表格数据
  //   .table {
  //     min-height: calc(100vh - 330px);
  //     border: 1px solid #ddd;
  //     border-radius: 10px;
  //     .studentLabel {
  //       display: inline-block;
  //       padding: 5px 10px;
  //       background-color: #409eff;
  //       color: #fff;
  //       border-radius: 4px;
  //       margin: 0 5px 5px 0;
  //     }
  //   }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }
  .operationItem:hover {
    color: red;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass {
  display: flex;
  align-items: flex-start;
  .p1 {
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2 {
    flex: 1;
  }
  .el-tag {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem {
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass + .editLabelClass {
  margin-top: 20px;
}
/deep/.el-input-number {
  width: 250px;
}

/deep/.noData {
  padding-top: 200px;
  .text {
    text-align: center;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .openClick {
    text-align: center;
  }
}

.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.flex-box {
  margin: 10px;
  display: flex;
  justify-content: space-around;
  height: 80px;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
}
.activeNumber {
  color: #f40;
}
.item_a1 {
  background-color: #f5f3ff;
}
.item_a2 {
  background-color: #edfffa;
}
.item_a3 {
  background-color: #fff6ed;
}
.item_a4 {
  background-color: #ffefef;
}
/deep/.el-dialog__footer {
  text-align: center;
}

.initialLogin {
  background: #ffebeb;
  border-radius: 8px 8px 8px 8px;
  line-height: 45px;
  padding: 0 20px 0 16px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  align-items: center;
  .initialLeft {
    color: #191b27;
    font-size: 15px;
    font-weight: 500;
  }
  .initialRight {
    height: 32px;
    width: 72px;
    background: linear-gradient(234deg, #ff6157 0%, #ff418a 100%);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    line-height: 32px;
    text-align: center;
    font-size: 13px;
    color: #ffffff;
    cursor: pointer;
  }
}

.questionIcon {
  width: 19px;
  height: 19px;
  background-image: url("../../assets/new/questionIcon_a1.png");
  background-size: 19px 19px;
  margin-top: -3px;
}
.questionIcon:hover {
  background-image: url("../../assets/new/questionIcon_a2.png");
  background-size: 19px 19px;
}
.initialNum {
  font-weight: bold;
  color: red;
  font-size: 20px;
  margin-bottom: 10px;
}

.fileListBox {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  .fileItem {
    width: 120px;
    text-align: center;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    .fileBtn {
      padding: 10px;
      border: none;
      .img {
        width: 100px;
        height: 100px;
      }
      .cont {
        display: block;
        width: 100px;
        word-wrap: break-word;
        white-space: break-spaces;
      }
    }
    /deep/.downloadBox {
      text-align: center !important;
    }
  }
}
.experienceCardBox {
  display: flex;
  justify-content: flex-start;
  .experienceLeft {
    // display: flex;
    // justify-content: space-between;
    padding: 20px;
    min-width: 600px;
    .experienceTitle {
      margin: 10px 0 20px 0;
      display: flex;
      justify-content: space-between;
      .left {
        font-size: 15px;
        font-weight: bold;
      }
      .right {
        color: #846ffd;
        cursor: pointer;
      }
    }
    .experienceCont {
      display: flex;
      justify-content: flex-start;
      // .experienceItem {
      //   text-align: center;
      //   padding: 20px;
      //   margin-right: 20px;
      //   border: 1px solid #dcdfe6;
      //   .itemTitle {
      //     margin-bottom: 10px;
      //   }
      //   .itemImg {
      //     margin-bottom: 10px;
      //   }
      //   .itemAccounts {
      //     margin-bottom: 10px;
      //   }
      //   .itemPassword {
      //   }
      //   .itemBtn {
      //     cursor: pointer;
      //     .btn {
      //       border: 1px solid #ddd;
      //       line-height: 30px;
      //       margin-top: 10px;
      //     }
      //   }
      // }
    }
  }
  .experienceRight {
    padding: 20px;
    margin-left: 20px;
    width: 22%;
    min-width: 360px;
    display: block;
  }
}
.accounts_h1 {
}
.accounts_h2 {
  text-align: center;
  margin-top: 20px;
}
.accounts_h3 {
  text-align: center;
  margin-top: 20px;
}
</style>
